function About() {
    return (
        <div className="About"></div>
    );
}

export { About };